export class StickyInfo {
    public __classname__: string = 'StickyInfo';

    public AnchorX : number | null = null;
	public AnchorY : number | null = null;
	public Left : number | null = null;
	public Top : number | null = null;
	public Width : number | null = null;
	public Height : number | null = null;
	public Page : number | null = null;
	public Version : string | null = null;
	public Color : string | null = null;
	public PageSequence : number | null = null;

    constructor(
        AnchorX: number | null = null,
        AnchorY: number | null = null,
        Left: number | null = null,
        Top: number | null = null,
        Width: number | null = null,
        Height: number | null = null,
        Page: number | null = null,
        Version: string | null = null,
        Color: string | null = null,
        PageSequence: number | null = null
    ) {
        this.AnchorX = AnchorX;
        this.AnchorY = AnchorY;
        this.Left = Left;
        this.Top = Top;
        this.Width = Width;
        this.Height = Height;
        this.Page = Page;
        this.Version = Version;
        this.Color = Color;
        this.PageSequence = PageSequence;
    }
}